import React from "react";

const FeaturesBento: React.FC = () => {
  return (
    <div className="flex justify-center items-center w-full">
      <div className="grid gap-5">
        <div className="grid gap-5 grid-cols-2 md:grid-cols-3 xl:gap-12">
          <div className="p-3">
            <div className="font-medium text-lg sm:text-2xl md:text-3xl lg:text-4xl xl:text-[3.2rem] xl:space-y-6 ">
              <h4>Features That</h4>
              <h4>Drive Results</h4>
            </div>
            <div>
              <h6 className="text-[#FF7E00] text-sm sm:text-base md:text-lg xl:text-xl pt-2 lg:pt-4 xl:pt-6">
                Built for Learners, Trainers, Admins, and IT Teams
              </h6>
              <p className="text-xs lg:text-sm">
                Dream LMS goes beyond basic e-learning systems to deliver a
                platform that works for everyone in your organization:
              </p>
            </div>
          </div>

          <div className="flex flex-col custom-hover gap-1 md:gap-3 bg-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl text-[#34368A]">
              01
            </h3>
            <div className="font-medium text-[#5C5C5C] xl:text-xl">
              For Learners:
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal ">
              Interactive dashboards, progress tracking, quizzes, and
              gamification make learning engaging and effective.
            </p>
          </div>
          <div className="flex flex-col custom-hover gap-1 md:gap-3 bg-[#34368A] text-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl">
              02
            </h3>
            <div className="font-medium xl:text-xl ">For Trainers:</div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              Content management tools, feedback systems, and analytics
              dashboards simplify delivery and ensure impact.
            </p>
          </div>
          <div className="flex flex-col custom-hover gap-1 md:gap-3 bg-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl text-[#34368A]">
              03
            </h3>
            <div className="font-medium text-[#5C5C5C] xl:text-xl">
              For Admins:
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              User management, advanced reporting, and compliance monitoring
              tools keep operations smooth.
            </p>
          </div>
          <div className="flex flex-col custom-hover gap-1 md:gap-3 bg-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl text-[#34368A]">
              04
            </h3>
            <div className="font-medium text-[#5C5C5C] xl:text-xl">
              For IT Heads:
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              Seamless integrations, enterprise-grade security, and scalable
              infrastructure ensure reliability.
            </p>
          </div>
          <div className="flex w-full  rounded-xl custom-hover ">
            <div className="relative w-full h-full md:h-56 lg:h-64">
              <img
                src="/skill/workplace.png"
                alt=""
                className="max-h-auto bg-contain bg-center w-full h-full md:w-full md:h-full"
              />
              <p className="absolute text-xs bottom-0 p-5 xl:text-xl text-white font-light md:text-lg">
                Managing Your Workforce, So You Can Focus on Growth
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesBento;
